import { createSlice } from "@reduxjs/toolkit";
import { ActionType } from "../care_recipient/actions";
import { getListAction } from "./actions";

export type AdminListState = Readonly<{
    list: {
        careRecipient: {
            id: string,
            name: string,
            dataSyncInformation: {
                houseId: string,
                serviceProviderId: string | null,
                dataSyncPeriod: {
                    startTime: string | null,
                    endTime: string | null
                } | null
            } | null
            birthday: string
            createdTime: string
        } | null,
        users: {
            id: string,
            name: string,
            account: {
                email: string,
                role: string
            }
        }[]
    }[] | null
    processing: number,
}>;

const adminListInitialState: AdminListState = {
    list: null,
    processing: 0,
};

const slice = createSlice({
    name: ActionType.base,
    initialState: adminListInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getListAction.pending,
                (state) => {
                    state.list = null;
                    state.processing += 1;
                }
            )
            .addCase(
                getListAction.fulfilled,
                (state, action) => {
                    state.list = action.payload.list;
                    state.processing -= 1;
                }
            )
            .addCase(
                getListAction.rejected,
                (state) => {
                    state.list = null;
                    state.processing -= 1;
                }
            );
    }
});

export const adminListReducer = slice.reducer;